const styles = (props) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
	},
	container: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: "16px",
		borderRadius: "22px",
		position: "relative",
		width: "450px",
		padding: {
			xs: "20px",
			sm: "20px",
		},
		background: props.palette.secondary.darker,
		maxWidth: "80vw",
	},
	title: {
		marginTop: "8px",
		color: props.palette.white.main,
		fontSize: "1.5rem",
		fontWeight: "bold",
		textAlign: "center",
	},
	iconButton: {
		position: "absolute",
		right: 16,
		top: 16,
		color: props.palette.white.main,
		padding: 0,
	},
	avatar: {
		transform: "translateX(-50%)",
		position: "absolute",
		left: 85,
		top: 25,
		height: "90px",
		width: "90px",
		border: "4px solid",
		borderColor: props.palette.secondary.darker,
		color: props.palette.white.main,
		background:
			props.palette.mode == "dark"
				? props.palette.colors.gray.dark
				: props.palette.black.light,
		"@media (max-width: 475px)": {
			display: "none",
		},
	},
	content: {
		background: props.palette.background.modalContrast,
		display: "flex",
		flexDirection: "column",
		paddingY: {
			xs: "10px",
			sm: "20px",
		},
		gap: "16px",
		borderRadius: "20px",
		width: "100%",
	},
	row: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		width: "100%",
		gap: "20px",
	},
	textField: {
		width: "80%",
		borderRadius: "8px",
		bgcolor:
			props.palette.mode == "dark"
				? props.palette.secondary.dark
				: props.palette.secondary.light,
		"& .MuiFilledInput-root": {
			backgroundColor: "transparent",
		},
		"& .Mui-disabled": {
			backgroundColor:
				props.palette.mode == "dark"
					? props.palette.secondary.dark
					: props.palette.secondary.light,
			borderRadius: "8px",
		},
		"& .MuiFilledInput-root:hover": {
			bgcolor:
				props.palette.mode == "dark"
					? props.palette.secondary.darker
					: props.palette.secondary.light,
		},
		"& .MuiInputLabel-filled": {
			color:
				props.palette.mode == "dark"
					? props.palette.colors.gray.light
					: props.palette.secondary.dark,
		},
		"& .MuiFilledInput-input": {
			color:
				props.palette.mode == "dark"
					? props.palette.white.main
					: props.palette.colors.black.dark,
		},
		"& .MuiInputBase-input.Mui-disabled": {
			WebkitTextFillColor:
				props.palette.mode == "dark"
					? props.palette.colors.gray.light
					: props.palette.colors.black.medium,
		},
	},
	cameraButton: {
		color: props.palette.white.main,
		background: props.palette.secondary.dark,
		"&:hover": {
			backgroundColor: props.palette.background.default,
		},
		position: "absolute",
		zIndex: "99",
		left: "25%",
		transform: "translateX(-50%)",
		top: 84,
	},
});

export default styles;
